const CenterQuestion = require('./CenterQuestion');

class LegUpList {
  constructor() {
    this.init();
  }

  init() {
    this.legup_id = undefined;
    this.list_id = undefined;
    this.market = undefined;
    this.custom_questions = undefined;
    this.subsidies = undefined;
  }

  copy() {
    const cp = new AgeGroup();

    cp.legup_id = this.legup_id;
    cp.list_id = this.list_id;
    cp.market = this.market;
    cp.subsidies = this.subsidies ? [].concat(this.subsidies) : undefined;

    if (this.custom_questions) {
      cp.custom_questions = [];
      this.custom_questions.forEach((q) => {
        cp.custom_questions.push(q.copy());
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      // Should we do validation on days, times, and question list?
      this.legup_id = obj.legup_id ? obj.legup_id.toString() : undefined;
      this.list_id = obj.list_id ? obj.list_id.toString() : undefined;
      this.market = obj.market ? obj.market : undefined;
      this.subsidies = obj.subsidies ? [].concat(obj.subsidies) : undefined;

      if (obj.custom_questions) {
        this.custom_questions = [];
        obj.custom_questions.forEach((q) => {
          const question = new CenterQuestion();
          question.buildFromJSON(q);
          this.custom_questions.push(question);
        });
      }
    }
  }

  toString() {
    let result = this.market ? this.market : '';
    return result;
  }

  getId() {
    return this.legup_id;
  }

  setId(legup_id) {
    this.legup_id = legup_id ? legup_id.toString() : undefined;
  }

  getListId() {
    return this.list_id;
  }

  setListId(list_id) {
    this.list_id = list_id ? list_id.toString() : undefined;
  }

  getMarket() {
    return this.market;
  }

  setMarket(market) {
    this.market = market;
  }

  getCustomQuestions() {
    return this.custom_questions;
  }

  setCustomQuestions(custom_questions) {
    this.custom_questions = undefined;
    if (custom_questions) {
      this.custom_questions = [];
      custom_questions.forEach((q) => {
        this.custom_questions.push(q.copy());
      });
    }
  }

  getSubsidies() {
    return this.subsidies || [];
  }

  setSubsidies(subsidies) {
    this.subsidies = subsidies ? [].concat(subsidies) : undefined;
  }
}

module.exports = LegUpList;
